import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { StudentMaster } from '../model/StudentMaster.model';
import { SessionClient } from '../configration/sessionclient.storage';
import { User } from '../model/User.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MainserviceService } from '../service/mainservice.service';
import Swal from 'sweetalert2';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  studentMaster:StudentMaster = new StudentMaster();
  user:User = new User();
  errorBean:any={};
  forgotpasswordotp:string;
  opnsendotp:boolean= false;
  errorInvalidUser:boolean=false;
  seconds: number; 
  minute: number;
  errorPhone:string=''
 
  interval;
  timeCompleted:boolean=false;


  value2: string;

  otppage:boolean=true;

  openforgetpassword:boolean= false;
  constructor(private authService:AuthService,private sessionClient:SessionClient,private router:Router,private mainService:MainserviceService, private messageService: MessageService) { }

  ngOnInit() {
     
  }

  floatClass(){
    document.getElementById('float').style.transform='translateX(6px) scale(0.7)';
    document.getElementById('float').style.transition='0.5s';
    document.getElementById('mobileinput').focus();
  }

  navigateRegister(){
    this.router.navigateByUrl('/register')
  }


  // login
  studentLogin(){
    // this.fetchUserDetails(true);

    let errorFlag=false;


    if(this.user.otp==null || this.user.otp == undefined || this.user.otp == ""){
      
      this.errorBean.invalidotp=true;
      return
    }

    if(this.user.otp!=this.user.actualOtp){
      
      this.errorBean.invalidotp=true;
      return
   }

    
   this.authService.setUserSession(this.studentMaster);
    this.getToken();
    this.errorBean.invalidotp=false;

    // Swal.fire({
    //   title: 'Success',
    //   text: 'Login successful!',
    //   icon: 'success',
    //   showCancelButton: true,
    //   showConfirmButton: true,
    // })

    // this.messageService.add({severity:'success', summary:'Login Successful', detail:''});
    
    
   

  }

 

  getToken(){
    this.authService.attemptAuth(this.user).subscribe(data=>{
      this.sessionClient.saveToken(data.token);
      this.getStudentDetailsByUsername()
      
     
    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        //json circular break at server side always add
            //extra information of timestamp and status along with
            //main json so parsing occurs still at status 200
          
        
            
          //  this.redirection();
      }else{
        this.messageService.add({severity:'error', summary:'Something went wrong', detail:''});
        // this.router.navigateByUrl('/login');
      }
    })
  }


  startTimer() {
    this.timeCompleted=false;
    this.seconds = 0;
    this.minute =1;
    this.interval = setInterval(() => {
      if(this.seconds > 0) {
        this.seconds--;
      } 
      else if(this.seconds == 0) {
        this.minute--
        this.seconds=59

        if(this.minute<0){
          this.seconds=0;
          this.minute=0
         
          this.pauseTimer();
        }
      }
      
      
      else {
        this.seconds = 10;
      }
    },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
    this.timeCompleted=true;
  }


  fetchUserDetails(){
    this.errorInvalidUser=false;
    if(this.user.username == null || this.user.username == undefined
     
      ){
        this.errorBean.invalidphone=true;
        this.errorPhone='* Please enter mobile number'
        return;
      }else{
    
    this.authService.getUserDetailsByUsername(this.user).subscribe(data=>{
    let userTemp=data

      this.errorBean.invalidphone=false;
      if(userTemp.id==0){
        this.errorInvalidUser=true;
        return;
      }else{
        this.user.phone = data.phone;
        this.sendOTP()
      }
    
     
    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        
      }
    })

  }
  }
  getStudentDetailsByUsername(){
   
    this.studentMaster.user = this.user;

    this.mainService.getStudentDetailsByUsername(this.studentMaster).subscribe(data=>{
      this.studentMaster = data;
      this.authService.setUserSession(this.studentMaster);
      this.router.navigateByUrl('/student-dashboard');

   
  })
  
  }
  // *******************************send OTP***************************
  sendOTP(){

   

     
    
    
    // this.opnsendotp= true;
    
    this.authService.sendOtpToUser(this.user).subscribe(data=>{
      this.user.actualOtp = data;
      // this.user.otp = this.user.actualOtp;
      if(this.user.actualOtp==null){
        this.errorBean.invalidphone=true;
        this.errorPhone='User Not Found.'
        return

        
      }else{
        this.errorBean.invalidphone=false;
        this.errorPhone=''
        this.otppage=false;
        this.startTimer();
        
      }

    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        let jsonString=err.error.text;
          // alert(jsonString);
        
        //json circular break at server side always add
            //extra information of timestamp and status along with
            //main json so parsing occurs still at status 200
          
        
            

          //  this.redirection();
      }
    })
  }
  // ****************************verify OTP*****************************************
  verifyOTP(){
    if (this.user.otp == this.forgotpasswordotp){
      alert("success");
      this.openforgetpassword= true;
    }
  }


  //  ********************forgotpassword***********************************************

  forgotPassword(){
  
    this.authService.forgetStudentPassword(this.user).subscribe(data=>{
     
      this.user = data;
     
    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        let jsonString=err.error.text;
          alert(jsonString);
        //json circular break at server side always add
            //extra information of timestamp and status along with
            //main json so parsing occurs still at status 200
          
        
            

          //  this.redirection();
      }
    })
  }
}
